<script setup lang="ts">
import { Popup, showFailToast, showLoadingToast, showSuccessToast } from "vant";
import PersonaIcon from "@/components/icon/PersonaIcon.vue";
import { Story, Visibility } from "@/types/entity";
import { ref } from "vue";
import { useStory } from "@/stores/story";
import i18n from "@/locales";

const props = defineProps<{
  story?: Story;
  show: boolean;
}>();
const emit = defineEmits<{
  (e: "update:show", value: boolean): void;
}>();

const visibility = ref<Visibility>(2);
const storyStore = useStory();
const publishMomentText = ref("");
const onPublishStory = async () => {
  if (!publishMomentText.value) {
    showFailToast(i18n.global.t("Message.notWrittenIntro"));
    return;
  }
  const loadingToast = showLoadingToast({
    message: i18n.global.t("Message.releasingChapterUniverse"),
  });
  try {
    await storyStore.publishStory(
      props.story!.id,
      props.story!.storyBook!.uuid,
      publishMomentText.value,
      visibility.value
    );
    loadingToast.close();
    showSuccessToast(i18n.global.t("Message.chapterPublishedSuccessfully"));
    emit("update:show", false);
  } finally {
    loadingToast.close();
  }
};
</script>
<template>
  <popup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="center"
    class="py-10 px-10"
    round
    teleport="body"
  >
    <div class="flex flex-col items-center justify-center w-full h-full gap-5">
      <div class="flex flex-col items-center justify-center gap-2">
        <persona-icon class="w-[20%] text-base-content/50" />
        <div class="text-lg font-bold text-base-content/50">
          {{ $t("Texts.whenChapterPublishedYourFeed") }}
        </div>
        <div class="text-base text-base-content/50">
          {{ $t("Texts.chapterPublishedNotModify") }}
        </div>
      </div>
      <div class="flex flex-col gap-2 w-full">
        <div class="flex flex-col gap-2">
          <span class="font-bold">{{ $t("Texts.contentChapter") }}</span>
          <textarea
            v-model="publishMomentText"
            class="textarea textarea-bordered"
            :placeholder="$t('Texts.contentChapterPlaceholder')"
          />
        </div>

        <div class="flex flex-col gap-2">
          <span class="font-bold">{{ $t("story.visibility") }}</span>
          <visibility-select v-model:visibility="visibility" />
        </div>
      </div>

      <div class="flex gap-2 justify-between items-center">
        <button
          class="btn rounded btn-primary btn-sm flex-1"
          @click="onPublishStory"
        >
          {{ $t("Buttons.publish") }}
        </button>
        <button
          class="btn rounded btn-sm flex-1"
          @click="emit('update:show', false)"
        >
          {{ $t("Buttons.cancel") }}
        </button>
      </div>
    </div>
  </popup>
</template>
